import axios from "../../axios/axios";
import { User } from "../../ts/Auth";
import { FetchedObchodnik } from "../../ts/UI";
import { IGenericResponse } from "../../types/server-api/common";
import {
  TAdminAddUserBody,
  TAdminChangePasswordBody,
  TAdminEditUserInfoBody,
  TAdminEditUserPermissionsBody,
  TChangePasswordBody,
  TEditUserInfoBody,
  TLoginUserBody,
} from "../../types/server-api/user";

import { APIRoutes } from "../server-api/routes";

interface ILoginUserResponse {
  token: string;
}

export interface IUserModel {
  loginUser: (data: TLoginUserBody) => Promise<ILoginUserResponse>;
  checkAuth: () => Promise<IGenericResponse>;
  changePassword: (data: TChangePasswordBody) => Promise<ILoginUserResponse>;
  getUser: (id: string) => Promise<User>;
  getUsers: (ids: string[]) => Promise<User[]>;
  getAllUsers: () => Promise<User[]>;

  editUserInfo: (data: TEditUserInfoBody) => Promise<ILoginUserResponse>;
  adminAddUser: (data: TAdminAddUserBody) => Promise<User>;
  adminChangePassword: (
    data: TAdminChangePasswordBody
  ) => Promise<IGenericResponse>;
  adminEditUserInfo: (data: TAdminEditUserInfoBody) => Promise<User>;
  adminEditUserPermissions: (
    data: TAdminEditUserPermissionsBody
  ) => Promise<User>;
  adminRemoveUser: (id: string) => Promise<IGenericResponse>;
}

export const userModel: IUserModel = {
  checkAuth: async () => {
    const res = await axios.post<IGenericResponse>(APIRoutes.User.Auth);

    return res.data;
  },
  loginUser: async (data) => {
    const res = await axios.post<ILoginUserResponse>(
      APIRoutes.User.Login,
      data
    );

    return res.data;
  },
  getUser: async (id) => {
    const res = await axios.get<User>(APIRoutes.User.FetchObchodnik, {
      params: { id },
    });

    return res.data;
  },
  getAllUsers: async () => {
    const res = await axios.get<User[]>(APIRoutes.User.FetchObchodnici);

    return res.data;
  },
  getUsers: async (ids) => {
    const res = await axios.get<User[]>(APIRoutes.User.FetchObchodniciByArray, {
      params: { array: ids },
    });

    return res.data;
  },
  editUserInfo: async (data) => {
    const res = await axios.post<ILoginUserResponse>(
      APIRoutes.User.EditUserInfo,
      data
    );

    return res.data;
  },
  changePassword: async (data) => {
    const res = await axios.post<ILoginUserResponse>(
      APIRoutes.User.ChangePassword,
      data
    );

    return res.data;
  },
  adminChangePassword: async (data) => {
    const res = await axios.post<IGenericResponse>(
      APIRoutes.User.AdminChangePassword,
      data
    );

    return res.data;
  },
  adminAddUser: async (data) => {
    const res = await axios.post<User>(APIRoutes.User.AdminAddUser, data);

    return res.data;
  },
  adminEditUserInfo: async (data) => {
    const res = await axios.post<User>(APIRoutes.User.AdminEditUserInfo, data);

    return res.data;
  },
  adminEditUserPermissions: async (data) => {
    const res = await axios.post<User>(
      APIRoutes.User.AdminEditUserPermissions,
      data
    );

    return res.data;
  },
  adminRemoveUser: async (_id) => {
    const res = await axios.post<IGenericResponse>(
      APIRoutes.User.AdminRemoveUser,
      {
        _id,
      }
    );

    return res.data;
  },
};
